// Maten van de filmkop die onder de doorzichtige kopbalk doorloopt. Twee
// verschillende hoogtes, die elk hun eigen breekpunt hebben:
//  - de SPACER onder de vaste kopbalk (layout.js): 70px, vanaf `lg` 106px;
//  - de echte KOPBALK (Navbar.js, py-3 xl:py-[30px]): 70px, vanaf `xl` 106px.
// Tussen 1024 en 1279px is de spacer dus 106px en de balk 70px. De film begint
// op y=0 en moet daarom de SPACER terugtrekken (marge), terwijl de pauzeknop en
// het scrollanker de echte BALK volgen. Eén plek, zodat ze nooit uit elkaar lopen.
export const SPACER_HOOGTE_PX = { basis: 70, lg: 106 };
export const KOPBALK_HOOGTE_PX = { basis: 70, xl: 106 };

/** Spacerklasse zoals in `src/app/(marketing)/layout.js` (de test vergelijkt ze). */
export const SPACER_KLASSE = "h-[70px] lg:h-[106px]";
/** Negatieve marge: trekt de film over de spacer, tot y=0. */
export const KOPBALK_MARGE_KLASSE = "-mt-[70px] lg:-mt-[106px]";
/** Eerste vrije regel onder de echte kopbalk (voor de pauzeknop). */
export const KOPBALK_TOP_KLASSE = "top-[70px] xl:top-[106px]";
/** Anker onder de echte kopbalk met 8px ademruimte. */
export const KOPBALK_SCROLL_MT_KLASSE = "scroll-mt-[78px] xl:scroll-mt-[114px]";
// Zichtbare fotohoogte (128/248/368, zoals op main) + spacer: titel, prijs en
// boekknop staan op elk scherm op dezelfde plek als voorheen.
export const DEALFILMKOP_HOOGTE_KLASSE = "h-[198px] sm:h-[318px] lg:h-[474px]";
